module.exports = __webpack_public_path__ + "images/pages/lp/estimate_process_4_02e312a87c0b57936abc0c44426fc540.png";